import axios from './axios-defaults';
jQuery(document).ready(function($){
    var locale = document.getElementsByTagName("html")[0].getAttribute("lang");

    $('#account_number').change(loadAccountQuestions);

    function loadAccountQuestions(){
        $('#link_harnois_account .invalid-feedback strong').text('');
		let valid;
        if ($('#account_number').val() == ''){
            $('#account_number').addClass('is-invalid')
            valid = false

            $('#account_number').parent().find('.invalid-feedback strong').text(account_required)
        }
        else{
            var accountCode = $('#account_number').val().trim();

			axios.post('/accounts/' + accountCode + '/isblocked')
				.then((blockResponse) => {
					if (blockResponse.data.isBlocked) {
						// If the account is blocked, show an error message and stop the process
						$('#questions-container').html('');
						$('#account_number').addClass('is-invalid');
						$('#account_number').parent().find('.invalid-feedback').find('strong').text(account_blocked_message);
						return;
					}

					axios.get('/accounts/authentificationQuestions?accountCode='+accountCode)
						.then((response) => {
							if (response && response.data && response.data.data){
								$('#questions-container').html(response.data)
								let localeCapitalized = locale.charAt(0).toUpperCase() + locale.slice(1)
								$.each(response.data.data, function(index, question){
									var question_html = jQuery('#question-template').clone().html();

									question_html = question_html.replaceAll('question_code', question.code)
									question_html = question_html.replaceAll('question_description', question['description'+localeCapitalized])

									$('#questions-container').append(question_html);
								});

								$('#link_harnois_account button[type=submit]').removeAttr('disabled')
							}
							else{
								$('#questions-container').html('');
								$('#account_number').addClass('is-invalid')
								$('#account_number').parent().find('.invalid-feedback').find('strong').text(account_invalid);
								$('#link_harnois_account button[type=submit]').attr('disabled','disabled')
							}
						}, (error) => {
							$('#questions-container').html('');
							$('#account_number').addClass('is-invalid')
							$('#account_number').parent().find('.invalid-feedback').find('strong').text(account_invalid);
						});

				})
				.catch((error) => {
					$('#questions-container').html('');
					$('#account_number').addClass('is-invalid')
					$('#account_number').parent().find('.invalid-feedback').find('strong').text(account_invalid);
				});
        }


    }

    $('#link_harnois_account').submit(function(event){
        event.preventDefault();

        if ($('#questions-container .input-field').length == 0)
            return false;

        $('#questions-container .input-field .is-invalid').removeClass('is-invalid').parent().find('.invalid-feedback strong').text('')
        $('#questions-container .input-field .invalid-feedback strong').text('')

        var dataArray = {};
        dataArray.accountCode = $('#account_number').val().trim();
        dataArray.authentificationAnswerList = []

        $('#link_harnois_account #questions-container .input-field').each(function(i){
            var qArray = {};
            let qCode = $(this).find('input[type=text]').attr('id')
            let qAnswer = $(this).find('input[type=text]').val()

            qArray.questionCode = qCode
            qArray.answer = qAnswer.trim();

            if (qAnswer == ''){
                $('input#'+qCode).addClass('is-invalid')
                    .parent().find('.invalid-feedback strong')
                    .text(account_question_required);
            }

            dataArray.authentificationAnswerList.push(qArray);
        })

        var dataJson = JSON.stringify(dataArray)
		let qCode;
		let qValid;

        axios.post('/auth/link-account/validate-answers', dataJson)
            .then((response) => {
                if (!response.data.succeeded){
                    $('input#account_number').addClass('is-invalid')
                        .parent().find('.invalid-feedback').show()
                        .find('strong').text(response.data.message)
                }
                else{
                    let valid = true;
                    $.each(response.data.data, function(index, item){
                        qCode = item.questionCode;
                        qValid = item.validAnswer;

                        if (!qValid){
                            valid = false
                            if (!$('input#'+qCode).parent().find('.invalid-feedback:visible').length)
                                $('input#'+qCode).addClass('is-invalid')
                                    .parent().find('.invalid-feedback').show()
                                    .find('strong').text(account_question_invalid)
                        }
                        else{
                            $('input#'+qCode).removeClass('is-invalid')
                                .parent().find('.invalid-feedback').hide()
                                .find('strong').text('')
                        }
                    })

                    if (valid){
                        event.currentTarget.submit();
                    }
                }
            }, (error) => {
                $.each(error.response.data.data, function (index, item) {
                    qCode = item.questionCode;
                    qValid = item.validAnswer;

                    if (!qValid) {
                        if (!$('input#' + qCode).parent().find('.invalid-feedback:visible').length)
                            $('input#' + qCode).addClass('is-invalid')
                                .parent().find('.invalid-feedback').show()
                                .find('strong').text(account_question_invalid)
                    } else {
                        $('input#' + qCode).removeClass('is-invalid')
                            .parent().find('.invalid-feedback').hide()
                            .find('strong').text('')
                    }
                })
            });
    })
})
